import React, { useEffect, useRef, useState } from "react"
import { Col, Row, Alert } from "reactstrap"

import { AvForm } from "availity-reactstrap-validation"
import FormButtons from "components/Services/FormComponents/FormButtons"

const StepOne = props => {
  const appDetailsFormRef = useRef(null)
  const [formBody, setformBody] = useState(<div></div>)

  useEffect(() => {
    setformBody(props.formBody)
  }, [props.formBody])

  const toggleNext = tab => {
    appDetailsFormRef.current.click()
  }

  const togglePrevious = tab => {}

  const toggleSubmit = tab => {}

  return (
    <>
      <AvForm
        onValidSubmit={(e, v) => {
          props.submit(v)
        }}
      >
        {props.error ? <Alert color="danger">{props.error}</Alert> : null}

        {/* Form Fields go here */}
        {formBody}
        {/* End of Form Fields */}

        {/* Hidden submit form button */}
        <Row style={{ display: "none" }}>
          <Col md={12}>
            <button
              ref={appDetailsFormRef}
              type="submit"
              style={{ float: "right", fontSize: 18 }}
              className="btn btn-primary col-3"
            >
              Next
            </button>
          </Col>
        </Row>
      </AvForm>
      <FormButtons
        activeTab={1}
        toggleNext={toggleNext}
        togglePrevious={togglePrevious}
        toggleSubmit={toggleSubmit}
      />
    </>
  )
}

export default StepOne
